<template>
    <div class="betslip-changes">
        <div
            v-if="isOnline"
            class="betslip__auto-updates"
        >
            <span class="betslip__auto-updates--label">
                <label for="exampleCheck1">
                    {{ $t('I accept automatic quota update') }}
                </label>
                <Tooltip :text="$t('Your bet will be placed even if odds change in the meantime!')">
                    <i class="icon--xs icon-info_circle betslip__auto-updates--icon"/>
                </Tooltip>
            </span>
            <input
                v-if="isOnline"
                :checked="autoUpdateChangesValue"
                @change="onChange"
                type="checkbox"
                class="checkbox"
                id="exampleCheck1"
                :disabled="isDisabled"
            >
            <label for="exampleCheck1"></label>
        </div>
        <div v-if="changes.length > 0" class="betslip-changes__cover">
            <div class="betslip-changes__wrapper">
                <div class="betslip-changes__title">
                    {{ $t('quota changed') | capitalize }}
                </div>
                <transition-group
                    name="animation-list__slide-in-left-"
                    tag="ul"
                    class="list--unstyled betslip-changes__event-list"
                >
                    <li
                        v-for="(change, index) in changes"
                        :key="`change-${index}`"
                        class="betslip-changes__change-item"
                    >
                        <div class="betslip-changes__change-item-wrapper">
                            <div class="betslip-changes__details">
                                <span class="betslip-changes__event">
                                    {{ change.selection.getEventFullName() }}
                                </span>
                                <span class="betslip-changes__message">
                                    <span class="betslip-changes__value old">
                                        {{ change.oldValue | twoDecimals}}
                                    </span>
                                    <span class="betslip-changes__value new">
                                        {{ change.newValue | twoDecimals}}
                                    </span>
                                </span>
                            </div>
                            <div class="betslip-changes__actions">

                                <span class="betslip-changes__decisions">
                                    <button
                                        @click="onDecline(change)"
                                        class="btn btn__secondary btn--sm"
                                    >
                                        {{ $t('decline') | upperCase }}
                                    </button>
                                    <button
                                        @click="onAccept(change)"
                                        class="btn btn__primary btn--sm"
                                    >
                                        {{ $t('accept') | upperCase }}
                                    </button>
                                </span>
                            </div>
                        </div>
                    </li>
                </transition-group>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Changes',
        props: {
            autoUpdateChangesValue: {
                type: Boolean,
                required: true,
            },
            changes: {
                type: Array,
                required: true
            },
            isDisabled: {
                type: Boolean,
                required: false,
                default: false,
            },
            isOnline: {
                type: Boolean,
                required: true,
            },
        },
        methods: {
            onChange() {
                this.$emit('autoUpdateChangesClick');
            },
            onAccept(change) {
                this.$emit('acceptChange', change);
            },
            onDecline(change) {
                this.$emit('declineChange', change);
            },
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/shared/betSlip/Changes.vue